import React from 'react';
import PropTypes from 'prop-types';
import { SuiDialog, SuiButton } from '@splashthat/sui';

const LABEL_CANCEL = 'Cancel';
const LABEL_CONFIRM = 'Okay';

const UserConfirmation = ({ message, onCancel, onConfirm }) => (
    <SuiDialog
        open
        actions={[
            <SuiButton key="Cancel" size="medium" onClick={onCancel} label={LABEL_CANCEL} variation="secondary" />,
            <SuiButton key="Confirm" size="medium" onClick={onConfirm} label={LABEL_CONFIRM} variation="primary" />,
        ]}
    >
        {message}
    </SuiDialog>
);

UserConfirmation.propTypes = {
    message: PropTypes.string.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};

export default UserConfirmation;
